/* tslint:disable */
/* eslint-disable */
/**
 * Spring API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AddFeedSummaryResponse,
  AddVideosResponse,
  BodyUploadFeedProtobufToS3ApiVideosFeedProtobufPost,
  BodyUploadVideoToGcsApiVideosUploadVideoGcsPost,
  BodyUploadVideoToS3ApiVideosUploadVideoPost,
  GetVideosResponse,
  HTTPValidationError,
  InputFeedSummary,
  InputUserVideoData,
  RandomVideoResponse,
} from '../models/index';
import {
    AddFeedSummaryResponseFromJSON,
    AddFeedSummaryResponseToJSON,
    AddVideosResponseFromJSON,
    AddVideosResponseToJSON,
    BodyUploadFeedProtobufToS3ApiVideosFeedProtobufPostFromJSON,
    BodyUploadFeedProtobufToS3ApiVideosFeedProtobufPostToJSON,
    BodyUploadVideoToGcsApiVideosUploadVideoGcsPostFromJSON,
    BodyUploadVideoToGcsApiVideosUploadVideoGcsPostToJSON,
    BodyUploadVideoToS3ApiVideosUploadVideoPostFromJSON,
    BodyUploadVideoToS3ApiVideosUploadVideoPostToJSON,
    GetVideosResponseFromJSON,
    GetVideosResponseToJSON,
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
    InputFeedSummaryFromJSON,
    InputFeedSummaryToJSON,
    InputUserVideoDataFromJSON,
    InputUserVideoDataToJSON,
    RandomVideoResponseFromJSON,
    RandomVideoResponseToJSON,
} from '../models/index';

export interface AddFeedSummaryApiVideosFeedSummaryPostRequest {
    inputFeedSummary: Array<InputFeedSummary>;
    xApiKey?: string | null;
}

export interface AddUserVideosDataApiVideosPostRequest {
    inputUserVideoData: Array<InputUserVideoData>;
    xApiKey?: string | null;
}

export interface CheckVideoExistsInGcsApiVideosCheckVideoExistsGcsGetRequest {
    awemeId: string;
    xApiKey?: string | null;
}

export interface CheckVideoExistsInS3ApiVideosCheckVideoExistsGetRequest {
    awemeId: string;
    xApiKey?: string | null;
}

export interface GetAllVideosApiVideosGetRequest {
    xApiKey?: string | null;
}

export interface GetRandomVideoApiVideosRandomPostRequest {
    xApiKey?: string | null;
}

export interface UploadFeedProtobufToS3ApiVideosFeedProtobufPostRequest {
    bodyUploadFeedProtobufToS3ApiVideosFeedProtobufPost: BodyUploadFeedProtobufToS3ApiVideosFeedProtobufPost;
    xApiKey?: string | null;
}

export interface UploadVideoToGcsApiVideosUploadVideoGcsPostRequest {
    bodyUploadVideoToGcsApiVideosUploadVideoGcsPost: BodyUploadVideoToGcsApiVideosUploadVideoGcsPost;
    xApiKey?: string | null;
}

export interface UploadVideoToS3ApiVideosUploadVideoPostRequest {
    bodyUploadVideoToS3ApiVideosUploadVideoPost: BodyUploadVideoToS3ApiVideosUploadVideoPost;
    xApiKey?: string | null;
}

/**
 * 
 */
export class VideosApi extends runtime.BaseAPI {

    /**
     * Add feed summary to the database
     * Add Feed Summary
     */
    async addFeedSummaryApiVideosFeedSummaryPostRaw(requestParameters: AddFeedSummaryApiVideosFeedSummaryPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AddFeedSummaryResponse>> {
        if (requestParameters['inputFeedSummary'] == null) {
            throw new runtime.RequiredError(
                'inputFeedSummary',
                'Required parameter "inputFeedSummary" was null or undefined when calling addFeedSummaryApiVideosFeedSummaryPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xApiKey'] != null) {
            headerParameters['x-api-key'] = String(requestParameters['xApiKey']);
        }


        let urlPath = `/api/videos/feed-summary`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['inputFeedSummary']!.map(InputFeedSummaryToJSON),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AddFeedSummaryResponseFromJSON(jsonValue));
    }

    /**
     * Add feed summary to the database
     * Add Feed Summary
     */
    async addFeedSummaryApiVideosFeedSummaryPost(requestParameters: AddFeedSummaryApiVideosFeedSummaryPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AddFeedSummaryResponse> {
        const response = await this.addFeedSummaryApiVideosFeedSummaryPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Add complete user video data to the database (video, snapshot, and view) Supports upsert behavior - if video exists, reuse it; always create new snapshot and view
     * Add User Videos Data
     */
    async addUserVideosDataApiVideosPostRaw(requestParameters: AddUserVideosDataApiVideosPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AddVideosResponse>> {
        if (requestParameters['inputUserVideoData'] == null) {
            throw new runtime.RequiredError(
                'inputUserVideoData',
                'Required parameter "inputUserVideoData" was null or undefined when calling addUserVideosDataApiVideosPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xApiKey'] != null) {
            headerParameters['x-api-key'] = String(requestParameters['xApiKey']);
        }


        let urlPath = `/api/videos`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['inputUserVideoData']!.map(InputUserVideoDataToJSON),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AddVideosResponseFromJSON(jsonValue));
    }

    /**
     * Add complete user video data to the database (video, snapshot, and view) Supports upsert behavior - if video exists, reuse it; always create new snapshot and view
     * Add User Videos Data
     */
    async addUserVideosDataApiVideosPost(requestParameters: AddUserVideosDataApiVideosPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AddVideosResponse> {
        const response = await this.addUserVideosDataApiVideosPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Check if a video already exists in GCS.
     * Check Video Exists In Gcs
     */
    async checkVideoExistsInGcsApiVideosCheckVideoExistsGcsGetRaw(requestParameters: CheckVideoExistsInGcsApiVideosCheckVideoExistsGcsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        if (requestParameters['awemeId'] == null) {
            throw new runtime.RequiredError(
                'awemeId',
                'Required parameter "awemeId" was null or undefined when calling checkVideoExistsInGcsApiVideosCheckVideoExistsGcsGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['awemeId'] != null) {
            queryParameters['aweme_id'] = requestParameters['awemeId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xApiKey'] != null) {
            headerParameters['x-api-key'] = String(requestParameters['xApiKey']);
        }


        let urlPath = `/api/videos/check-video-exists-gcs`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Check if a video already exists in GCS.
     * Check Video Exists In Gcs
     */
    async checkVideoExistsInGcsApiVideosCheckVideoExistsGcsGet(requestParameters: CheckVideoExistsInGcsApiVideosCheckVideoExistsGcsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.checkVideoExistsInGcsApiVideosCheckVideoExistsGcsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Check if a video already exists in S3.
     * Check Video Exists In S3
     */
    async checkVideoExistsInS3ApiVideosCheckVideoExistsGetRaw(requestParameters: CheckVideoExistsInS3ApiVideosCheckVideoExistsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        if (requestParameters['awemeId'] == null) {
            throw new runtime.RequiredError(
                'awemeId',
                'Required parameter "awemeId" was null or undefined when calling checkVideoExistsInS3ApiVideosCheckVideoExistsGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['awemeId'] != null) {
            queryParameters['aweme_id'] = requestParameters['awemeId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xApiKey'] != null) {
            headerParameters['x-api-key'] = String(requestParameters['xApiKey']);
        }


        let urlPath = `/api/videos/check-video-exists`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Check if a video already exists in S3.
     * Check Video Exists In S3
     */
    async checkVideoExistsInS3ApiVideosCheckVideoExistsGet(requestParameters: CheckVideoExistsInS3ApiVideosCheckVideoExistsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.checkVideoExistsInS3ApiVideosCheckVideoExistsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all videos from the database
     * Get All Videos
     */
    async getAllVideosApiVideosGetRaw(requestParameters: GetAllVideosApiVideosGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetVideosResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xApiKey'] != null) {
            headerParameters['x-api-key'] = String(requestParameters['xApiKey']);
        }


        let urlPath = `/api/videos`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetVideosResponseFromJSON(jsonValue));
    }

    /**
     * Get all videos from the database
     * Get All Videos
     */
    async getAllVideosApiVideosGet(requestParameters: GetAllVideosApiVideosGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetVideosResponse> {
        const response = await this.getAllVideosApiVideosGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a random video from the database
     * Get Random Video
     */
    async getRandomVideoApiVideosRandomPostRaw(requestParameters: GetRandomVideoApiVideosRandomPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RandomVideoResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xApiKey'] != null) {
            headerParameters['x-api-key'] = String(requestParameters['xApiKey']);
        }


        let urlPath = `/api/videos/random`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RandomVideoResponseFromJSON(jsonValue));
    }

    /**
     * Get a random video from the database
     * Get Random Video
     */
    async getRandomVideoApiVideosRandomPost(requestParameters: GetRandomVideoApiVideosRandomPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RandomVideoResponse> {
        const response = await this.getRandomVideoApiVideosRandomPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Upload tiktok feed gzip compressed protobuf to S3
     * Upload Feed Protobuf To S3
     */
    async uploadFeedProtobufToS3ApiVideosFeedProtobufPostRaw(requestParameters: UploadFeedProtobufToS3ApiVideosFeedProtobufPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['bodyUploadFeedProtobufToS3ApiVideosFeedProtobufPost'] == null) {
            throw new runtime.RequiredError(
                'bodyUploadFeedProtobufToS3ApiVideosFeedProtobufPost',
                'Required parameter "bodyUploadFeedProtobufToS3ApiVideosFeedProtobufPost" was null or undefined when calling uploadFeedProtobufToS3ApiVideosFeedProtobufPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xApiKey'] != null) {
            headerParameters['x-api-key'] = String(requestParameters['xApiKey']);
        }


        let urlPath = `/api/videos/feed-protobuf`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BodyUploadFeedProtobufToS3ApiVideosFeedProtobufPostToJSON(requestParameters['bodyUploadFeedProtobufToS3ApiVideosFeedProtobufPost']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Upload tiktok feed gzip compressed protobuf to S3
     * Upload Feed Protobuf To S3
     */
    async uploadFeedProtobufToS3ApiVideosFeedProtobufPost(requestParameters: UploadFeedProtobufToS3ApiVideosFeedProtobufPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.uploadFeedProtobufToS3ApiVideosFeedProtobufPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Upload a video to GCS. Accepts base64-encoded video bytes from the bot.
     * Upload Video To Gcs
     */
    async uploadVideoToGcsApiVideosUploadVideoGcsPostRaw(requestParameters: UploadVideoToGcsApiVideosUploadVideoGcsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['bodyUploadVideoToGcsApiVideosUploadVideoGcsPost'] == null) {
            throw new runtime.RequiredError(
                'bodyUploadVideoToGcsApiVideosUploadVideoGcsPost',
                'Required parameter "bodyUploadVideoToGcsApiVideosUploadVideoGcsPost" was null or undefined when calling uploadVideoToGcsApiVideosUploadVideoGcsPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xApiKey'] != null) {
            headerParameters['x-api-key'] = String(requestParameters['xApiKey']);
        }


        let urlPath = `/api/videos/upload-video-gcs`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BodyUploadVideoToGcsApiVideosUploadVideoGcsPostToJSON(requestParameters['bodyUploadVideoToGcsApiVideosUploadVideoGcsPost']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Upload a video to GCS. Accepts base64-encoded video bytes from the bot.
     * Upload Video To Gcs
     */
    async uploadVideoToGcsApiVideosUploadVideoGcsPost(requestParameters: UploadVideoToGcsApiVideosUploadVideoGcsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.uploadVideoToGcsApiVideosUploadVideoGcsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Upload a video to S3. Accepts base64-encoded video bytes from the bot.
     * Upload Video To S3
     */
    async uploadVideoToS3ApiVideosUploadVideoPostRaw(requestParameters: UploadVideoToS3ApiVideosUploadVideoPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['bodyUploadVideoToS3ApiVideosUploadVideoPost'] == null) {
            throw new runtime.RequiredError(
                'bodyUploadVideoToS3ApiVideosUploadVideoPost',
                'Required parameter "bodyUploadVideoToS3ApiVideosUploadVideoPost" was null or undefined when calling uploadVideoToS3ApiVideosUploadVideoPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xApiKey'] != null) {
            headerParameters['x-api-key'] = String(requestParameters['xApiKey']);
        }


        let urlPath = `/api/videos/upload-video`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BodyUploadVideoToS3ApiVideosUploadVideoPostToJSON(requestParameters['bodyUploadVideoToS3ApiVideosUploadVideoPost']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Upload a video to S3. Accepts base64-encoded video bytes from the bot.
     * Upload Video To S3
     */
    async uploadVideoToS3ApiVideosUploadVideoPost(requestParameters: UploadVideoToS3ApiVideosUploadVideoPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.uploadVideoToS3ApiVideosUploadVideoPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
